import { http } from "@/utils";

const register = {
  /**
   * 注册
   * @param data
   * @return {*}
   */
  register(data) {
    let url = "/";
    return http.post(url, data).then((res) => res.data);
  },
  /**
   * 登录
   * @param data
   * @return {*}
   */
  login(data) {
    let url = "/uuos/login";
    return http.post(url, data).then((res) => res.data);
  },
  /**
   * 获取用户信息
   * @param data
   * @return {*}
   */
  getUserInfo(data) {
    let url = "/uuos/user_info";
    return http.post(url, data).then((res) => res.data);
  },
  /**
   * 企业微信扫码登录
   * @param data
   * @return {*}
   */
  wechatLogin(data) {
    let url = "/uuos/wechat_login";
    return http.post(url, data).then((res) => res.data);
  },
  sendAuthCode(data) {
    let url = '/uuos/send_sms';
    return http.post(url, data).then(res => res.data);
  },
  resetPassword(data) {
    let url = '/uuos/retrieve_password';
    return http.post(url, data).then(res => res.data);
  },
};

export default register;
